import React, {useCallback} from 'react';

import {type PaginationChangeHandler, PaginationStripe} from '@pb/kit-component-pagination';

type Props = {
    pagination: {page: number, size: number},
    totalCount: number,
    onChangePage: (page: number) => void,
    onChangePageSize: (size: number) => void,
};

const MIN_PAGE_SIZE = 25;

export const VendorManagementPagination: React.FC<Props> = ({
    pagination,
    totalCount,
    onChangePage,
    onChangePageSize,
}) => {
    const handleChangePageSize = useCallback((_currentPage: number, pageSize: number) => {
        const nextSize = Math.max(pageSize, MIN_PAGE_SIZE);
        onChangePageSize(nextSize);
        window.scrollTo(0, 0);
    }, [onChangePageSize]);

    const handlePaginationChange = useCallback<PaginationChangeHandler>(({currentPage}) => {
        onChangePage(currentPage);
    }, [onChangePage]);

    return (
        <PaginationStripe
            goToPage={true}
            pageSize={pagination.size}
            totalCount={totalCount}
            currentPage={pagination.page}
            onPaginationChange={handlePaginationChange}
            onChangePaginationSize={handleChangePageSize}
            sizeSwitcherPosition="LEFT"
            sizeSwitcherType="ONLY_PAGE_SIZE"
            sizes={[MIN_PAGE_SIZE, 50, 100, 250]}
        />
    );
};
